<template>
	<div class="main-table-freight">
		<div class="main-table-box">
			<el-table
				class="grid-content"
				:data="tableData"
				border
				stripe
				@row-dblclick='rowClick'
				:height="tableHeight"
				ref="table"
				@select="handleSelectionChange"
				@select-all="handleSelectionChange"
			>
				<el-table-column
					type="selection"
					align="center"
					width="50">
				</el-table-column>
				<el-table-column
					prop="shopName"
					label="门店名称"
					align="center">
					<template slot-scope="scope">
						<div class="over-hidden">{{scope.row.shopName}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="customerName"
					label="客户名称"
					align="center">
					<template slot-scope="scope">
						<div class="over-hidden">{{scope.row.customerName}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="customerCategoryName"
					label="客户类别"
					align="center">
				</el-table-column>
				<el-table-column
					prop="customerlevelname"
					label="会员等级"
					align="center">
					<template slot-scope="scope">
						{{scope.row.level === 0 ? scope.row.customerlevelname : scope.row.levelName + (scope.row.customerlevelname === '' ? '' : '-') + scope.row.customerlevelname }}
					</template>
				</el-table-column>
				<!-- <el-table-column
					prop="customerLevel"
					label="客户等级"
					align="center">
				</el-table-column> -->
				<el-table-column
					prop="freightTemplateName"
					label="整单运费"
					align="center">
					<template slot="header">
						<div>整单运费
							<el-tooltip class="item" effect="dark" content="买家提单运费计算规则为:整单运费+特殊商品运费" placement="top-start">
								<img src="~/images/icon/tooltip-icon.png" style="display: inline-block;cursor:pointer">
							</el-tooltip>
						</div>
					</template>
					<template slot-scope="scope">
						<div class="under-line" v-if="scope.row.freightTemplateName" @click="goDetail(scope.row.freightTemplateId)">{{scope.row.freightTemplateName}}</div>
						<div v-else>— —</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="productFreightTemplateName"
					label="特殊商品运费"
					align="center">
					<template slot="header">
						<div>特殊商品运费
							<el-tooltip class="item" effect="dark" content="特殊商品运费独立生效,不参与整单计费 " placement="top-start">
								<img src="~/images/icon/tooltip-icon.png" style="display: inline-block;cursor:pointer">
							</el-tooltip>
						</div>
					</template>
					<template slot-scope="scope">
						<div class="under-line" v-if="scope.row.productFreightTemplateName" @click="goSpecialDetail(scope.row.productFreightTemplateId)">{{scope.row.productFreightTemplateName}}</div>
						<div v-else>— —</div>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="220" align="center">
					<template slot-scope="scope">
						<el-button type='text' size="mini" @click="setTemplate(scope.row)" v-if="AuthorityList['01_0003_0001_00']">设置运费模板</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<el-pagination
			@size-change="handleSizeChange"
			@current-change="handlePageChange"
			:current-page="pagination.page"
			:page-sizes="[20, 40, 60, 100, 300]"
			:page-size="pagination.size"
			layout="total, sizes, prev, pager, next, jumper"
			:total="totalCount">
		</el-pagination>
		<el-dialog class="dialog-title" title="选择运费模板" :visible.sync="dialogModel" @close="dialogClose" width='850px' :close-on-click-modal="false">
			<div class="type-box">
				<div>
					<el-radio-group v-model="templateType" size="small" @change="getTemplate">
						<el-radio-button :label="-1">全部模板({{temTotalCount}})</el-radio-button>
						<el-radio-button :label="0">整单运费({{temNormalCount}})</el-radio-button>
						<el-radio-button :label="1">特殊商品运费({{temSpecCount}})</el-radio-button>
					</el-radio-group>
				</div>
				<div style="width:250px">
					<el-input
						v-model="templateName"
						placeholder="搜索"
						size="small"
						@keyup.enter.native="getTemplate">
						<el-button slot="append" icon="el-icon-search" @click="getTemplate"></el-button>
					</el-input>
				</div>
			</div>
			<div class="template-list">
				<div class="template-li" v-for="(item, index) in templateList" :key="item.id" @click="toggleTemplate(item, index)">
					<div class="template-head">
						<i class="el-icon-caret-bottom" v-show="item.showFlag"></i>
						<i class="el-icon-caret-right" v-show="!item.showFlag"></i>
						<img src="~/images/icon/special-icon.png" v-if="item.type === 1">
						<span style="font-weight:bold">{{item.name}}</span>
						<span style="margin-left: 10px" v-if="item.freeflag">
							参与免运费（
							<span v-if="item.freearea === 1"> 限区域 </span>
							<span v-if="item.freearea === 0">
								不限区域订单商品金额满{{ item.freemoney }}元
							</span>
							）
						</span>
						<div class="head-right" @click.stop="">
							<span v-if="item.checked">当前</span><el-checkbox v-model="item.checked" @change="checkHandle(item, index)"></el-checkbox>
						</div>
					</div>
					<div class="template-content" v-show="item.showFlag">
						<div v-if="item.type === 0">
							<el-table
								class="grid-content"
								:data="item.detailList"
								size="mini"
								ref="table"
								:span-method="objectSpanMethod"
							>
								<el-table-column
									prop="staffName"
									label="配送区域"
									align="center">
									<template slot-scope="scope">
										<el-tooltip effect="dark" :content="scope.row.areaname" placement="top-start">
											<div class="over-hidden">{{scope.row.showname}}</div>
										</el-tooltip>
									</template>
								</el-table-column>
								<el-table-column
									prop="freemoney"
									v-if="item.freeflag && item.freearea === 1"
									label="免运费规则"
									align="center">
									<template slot-scope="scope">
										<div>
											订单商品金额满{{ scope.row.freemoney }}元免运费
										</div>
									</template>
								</el-table-column>
								<el-table-column
									prop="transportMode"
									label="运输方式"
									align="center">
									<template slot-scope="scope">
										<div>
											<div v-if="scope.row.transportMode === 0">不限</div>
											<div v-if="scope.row.transportMode === 1">常温运输</div>
											<div v-if="scope.row.transportMode === 2">冷链运输</div>
										</div>
									</template>
								</el-table-column>
								<el-table-column
									prop="customerName"
									label="计费方式">
									<template slot-scope="scope">
										<div class="over-hidden" v-if="scope.row.pricingType === 0">一口价</div>
										<div class="over-hidden" v-if="scope.row.pricingType === 1">阶梯价</div>
										<div class="over-hidden" v-if="scope.row.pricingType === 2">比例价</div>
										<div class="over-hidden" v-if="scope.row.pricingType === 5">固定件数</div>
										<div class="over-hidden" v-if="scope.row.pricingType === 6">阶梯件数</div>
										<div class="over-hidden" v-if="scope.row.pricingType === 7">固定重量</div>
										<div class="over-hidden" v-if="scope.row.pricingType === 9">阶梯件数：超出起步价部分，每件</div>
										<div class="over-hidden" v-if="scope.row.pricingType === 10">阶梯件数：超出起步价部分，一律每件</div>
									</template>
								</el-table-column>
								<el-table-column
									prop="itemCount"
									label="计费规则">
									<template slot-scope="scope">
										<div class="flex-two">
											<div class="rule-box" v-if="scope.row.pricingType === 0">
												<div v-for="item in scope.row.freightTemplatePricingDTOList" :key="item.id">一口价{{item.freightMoney}}元</div>
											</div>
											<div class="rule-box two-box" v-if="scope.row.pricingType === 1">
												<div v-for="(childItem, childIndex) in scope.row.freightTemplatePricingDTOList" :key="childIndex" class="two-wrap">
													<div class="step-box">订单金额于{{childItem.minValue}}元（含）~{{childItem.maxValue}}元（不含）
													，收{{childItem.freightMoney}}元</div>
												</div>
											</div>
											<div class="rule-box" style="display:flex;align-items:center;" v-if="scope.row.pricingType === 2">
												<div v-for="item in scope.row.freightTemplatePricingDTOList" :key="item.id">订单金额比例的{{item.percentMoney}}%</div>
											</div>
											<div class="rule-box" style="display:flex;align-items:center;" v-if="scope.row.pricingType === 5">
												<div v-for="item in scope.row.freightTemplatePricingDTOList" :key="item.id">首费：{{item.maxValue}}件（包含及以下）,{{item.freightMoney}}元；续费：超出每件{{item.stepMoney}}元；{{item.topOffValue ? '封顶' + item.topOffValue + '件' : '无封顶'}}</div>
											</div>
											<div class="rule-box two-box" v-if="scope.row.pricingType === 6">
												<div v-for="(childItem, childIndex) in scope.row.freightTemplatePricingDTOList" :key="childIndex" class="two-wrap">
													<div class="step-box">订单件数于{{childItem.minValue}}件（含）~{{childItem.maxValue}}件（不含）
													，收{{childItem.freightMoney}}元</div>
												</div>
											</div>
											<div class="rule-box" style="display:flex;align-items:center;" v-if="scope.row.pricingType === 7">
												<div v-for="item in scope.row.freightTemplatePricingDTOList" :key="item.id">首费：{{item.maxValue}}KG（包含及以下）,{{item.freightMoney}}元；续费：超出每KG{{item.stepMoney}}元；{{item.topOffValue ? '封顶' + item.topOffValue + 'KG' : '无封顶'}}</div>
											</div>
											<div class="rule-box two-box" v-if="scope.row.pricingType === 9">
												<template>
													<div v-for="(childItem, childIndex) in scope.row.freightTemplatePricingDTOList" :key="childIndex" class="two-wrap">
														<div v-if="childIndex === 0" class="step-box">{{childItem.minValue}} ~ {{childItem.maxValue}} 件（不含），运费固定 {{childItem.freightMoney}} 元，{{ scope.row.detailtype === 1 ? '超出起送件数，超出部分每件' : '超出起送件数，每件' }}</div>
														<div v-else class="step-box">{{childItem.minValue}} ~ {{childItem.maxValue}} 件（不含），按照每件 {{childItem.freightMoney}} 元收取</div>
													</div>
												</template>
											</div>
											<div class="rule-box" style="display:flex;align-items:center;" v-if="scope.row.pricingType === 10">
												<div v-for="item in scope.row.freightTemplatePricingDTOList" :key="item.id">
													0-{{item.maxValue}}件，起步价{{item.freightMoney}}元，只要超出起步件数，一律按照每件{{item.stepMoney}}元收取
												</div>
											</div>
										</div>
									</template>
								</el-table-column>
							</el-table>
						</div>
						<div v-if="item.type === 1">
							<el-table
								class="grid-content"
								:data="item.detailList"
								ref="table2"
								:span-method="objectSpanMethod"
							>
								<el-table-column
									prop="showname"
									label="配送区域"
									align="center">
									<template slot-scope="scope">
										<div :title="scope.row.areaname">{{scope.row.showname}}</div>
									</template>
								</el-table-column>
								<el-table-column
									prop="productName"
									label="商品"
									align="center">
								</el-table-column>
								<el-table-column
									prop="transportMode"
									label="运输方式"
									align="center">
									<template slot-scope="scope">
										<div>
											<div v-if="scope.row.transportMode === 0">不限</div>
											<div v-if="scope.row.transportMode === 1">常温运输</div>
											<div v-if="scope.row.transportMode === 2">冷链运输</div>
										</div>
									</template>
								</el-table-column>
								<el-table-column
									prop="productAttrplanName"
									label="规格"
									align="center">
								</el-table-column>
								<el-table-column
									prop="pricingType"
									label="计费方式"
									align="center">
									<template slot-scope="scope">
										<div>
											<div v-if="scope.row.pricingType === 3">计重</div>
											<div v-if="scope.row.pricingType === 8">计件：固定件数</div>
											<div v-if="scope.row.pricingType === 4">计件：阶梯件数</div>
										</div>
									</template>
								</el-table-column>
								<el-table-column
									prop="pricingType"
									label="计费规则"
									align="center">
									<template slot-scope="scope">
										<div class="flex-two table-box">
											<div v-if="scope.row.pricingType === 4" style="text-align:left">
												<div class="rule-box two-box">
													<div v-for="(childItem, childIndex) in scope.row.freightTemplatePricingDTOList" :key="childIndex" class="two-wrap">
														<div class="step-box">
															商品于{{childItem.minValue}}件（不含）~{{childItem.maxValue}}件（不含），收
															{{childItem.freightMoney}}元</div>
													</div>
													<div v-if="scope.row.freeMoney">该商品金额满{{scope.row.freeMoney}}元，免运费。</div>
												</div>
											</div>
											<div v-if="scope.row.pricingType === 3" style="text-align:left">
												商品于0kg（含）~{{scope.row.freightTemplatePricingDTOList[0].maxValue}}kg（含），收{{scope.row.freightTemplatePricingDTOList[0].freightMoney}}
												元，每增加{{scope.row.freightTemplatePricingDTOList[0].stepValue}}kg，加收
												{{scope.row.freightTemplatePricingDTOList[0].stepMoney}}元
												<div v-if="scope.row.freeMoney">该商品金额满{{scope.row.freeMoney}}元，免运费。</div>
											</div>
											<div v-if="scope.row.pricingType === 8" style="text-align:left">
												商品于0件（含）~{{scope.row.freightTemplatePricingDTOList[0].maxValue}}件（含），收{{scope.row.freightTemplatePricingDTOList[0].freightMoney}}
												元，每增加{{scope.row.freightTemplatePricingDTOList[0].stepValue}}件，加收
												{{scope.row.freightTemplatePricingDTOList[0].stepMoney}}元
												<div v-if="scope.row.freeMoney">该商品金额满{{scope.row.freeMoney}}元，免运费。</div>
											</div>
										</div>
									</template>
								</el-table-column>
							</el-table>
						</div>
					</div>
				</div>
			</div>
			<div class="btn-box">
				<el-button class="btn" size="small" plain type="primary" @click="close">取消</el-button>
				<el-button class="btn" size="small" type="primary" @click="confirmTemplate">确认</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: 'mainTable',
	props: {
		tableData: {
			type: Array
		},
		totalCount: {
			type: Number
		},
		size: {
			type: Number,
			default: 20
		},
		page: {
			type: Number,
			default: 1
		},
		AuthorityList: {
			type: Object
		},
		needauditingflag: Boolean,
		canundeliveredunpaysendflag: Boolean
	},
	data () {
		return {
			tableHeight: '100%',
			pagination: {
				page: this.page,
				size: this.size
			},
			tableSelectUtils: this.$fxUtils.tableSelectUtils({
				key: 'uniqueId'
			}),
			dialogModel: false,
			templateType: -1,
			templateName: '',
			templateList: [],
			temTotalCount: 0,
			temNormalCount: 0,
			temSpecCount: 0,
			chooseData: {},
			chooseId: '',
			normalId: '',
			specialId: ''
		}
	},
	created () {
		// this.getAuthority('07_0001_0000_00')
	},
	computed: {
		ids () {
			return this.tableSelectUtils.getSelectRows()
		}
	},
	methods: {
		goDetail (id) {
			this.$router.push({ path: '/main/freightEdit', query: { id: id } })
		},
		goSpecialDetail (id) {
			this.$router.push({ path: '/main/freightSpecial', query: { id: id } })
		},
		checkHandle (item, index) {
			this.templateList.forEach((e, i) => {
				if (i !== index && item.type === e.type) {
					e.checked = false
				}
			})
			if (item.type === 0) {
				this.normalId = item.checked ? item.id : ''
			} else if (item.type === 1) {
				this.specialId = item.checked ? item.id : ''
			}
		},
		confirmTemplate () {
			// let normalId = ''
			// let specialId = ''
			// this.templateList.forEach(e => {
			// 	if (e.checked) {
			// 		if (e.type === 0) {
			// 			normalId = e.id
			// 		} else if (e.type === 1) {
			// 			specialId = e.id
			// 		}
			// 	}
			// })
			let customerId, shopId
			this.tableData.forEach(e => {
				if (e.uniqueId === this.chooseId) {
					customerId = e.customerId
					shopId = e.shopId
					// listId = e.id
				}
			})
			let params = [{
				// id: listId,
				customerId: customerId,
				shopId: shopId,
				freightTemplateId: this.normalId || 0,
				productFreightTemplateId: this.specialId || 0
			}]
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/relCustomerFreightTempalte/update`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('设置成功')
					this.$emit('modifySuc')
					this.dialogModel = false
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		close () {
			this.dialogModel = false
		},
		dialogClose () {
			this.chooseData = {}
			this.chooseId = ''
		},
		getTemplate () {
			let params = {
				name: this.templateName,
				type: this.templateType
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/freightTemplate/list/get`,
				data: params
			}).then(res => {
				this.temTotalCount = res.data.totalFreightTemplateCount
				this.temNormalCount = res.data.normalFreightTemplateCount
				this.temSpecCount = res.data.specialProductFreightTemplateCount
				let arr1 = []
				let arr2 = []
				if (res.data.freightTemplateDTOList !== null) {
					res.data.freightTemplateDTOList.forEach(e => {
						e.showFlag = false
						e.checked = false
						e.detailList = []
						if (this.normalId === e.id || this.specialId === e.id) {
							e.checked = true
							arr1.push(e)
						} else {
							arr2.push(e)
						}
					})
				}
				this.templateList = [...arr1, ...arr2]
				for (let i = 0; i < this.templateList.length; i++) {
					if (this.templateList[i].checked) {
						this.toggleTemplate(this.templateList[i], i)
					}
				}
			})
		},
		toggleTemplate (item, index) {
			if (item.detailList.length !== 0) {
				item.showFlag = !item.showFlag
			} else {
				let params = {
					id: item.id
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlSV}/order/freightTemplate/detail/get`,
					data: params
				}).then(res => {
					if (res.result === true) {
						if (item.type === 0) {
							let arr = []
							res.data.freightTemplateDetailDTOList.forEach(e => {
								if (e.areaname.split(',').length > 20) {
									e.showname = e.areaname.split(',').slice(0, 21).join(',') + '...'
								} else {
									e.showname = e.areaname
								}
								e.freemoney = this.$fxUtils.toFixedSHW(e.freemoney, 2)
								if (e.freightTemplatePricingDetail !== null) {
									let row = {}
									let dto = []
									e.freightTemplatePricingDetail.freightTemplatePricingDTOList.forEach(item => {
										row.showname = e.showname
										row.areaname = e.areaname
										row.freemoney = e.freemoney
										row.transportMode = 0
										row.pricingType = e.freightTemplatePricingDetail.pricingType
										row.detailtype = e.freightTemplatePricingDetail.detailtype
										item.freightMoney = this.$fxUtils.toFixedSHW(item.freightMoney, 2)
										item.percentMoney = this.$fxUtils.toFixedSHW(item.freightRatio, 2)
										if (item.pricingType !== 5 && item.pricingType !== 6) {
											item.minValue = this.$fxUtils.toFixedSHW(item.minValue, 2)
											item.maxValue = item.maxValue === null ? '' : this.$fxUtils.toFixedSHW(item.maxValue, 2)
										}
										dto.push(item)
									})
									row.freightTemplatePricingDTOList = dto
									arr.push(row)
								}
								if (e.simpleTemplatePricingDetail !== null) {
									let row = {}
									let dto = []
									e.simpleTemplatePricingDetail.freightTemplatePricingDTOList.forEach(item => {
										row.showname = e.showname
										row.areaname = e.areaname
										row.freemoney = e.freemoney
										row.pricingType = e.simpleTemplatePricingDetail.pricingType
										row.detailtype = e.simpleTemplatePricingDetail.detailtype
										row.transportMode = 1
										item.freightMoney = this.$fxUtils.toFixedSHW(item.freightMoney, 2)
										item.percentMoney = this.$fxUtils.toFixedSHW(item.freightRatio, 2)
										if (item.pricingType !== 5 && item.pricingType !== 6) {
											item.minValue = this.$fxUtils.toFixedSHW(item.minValue, 2)
											item.maxValue = item.maxValue === null ? '' : this.$fxUtils.toFixedSHW(item.maxValue, 2)
										}
										dto.push(item)
									})
									row.freightTemplatePricingDTOList = dto
									arr.push(row)
								}
								if (e.coldChainTemplatePricingDetail !== null) {
									let row = {}
									let dto = []
									e.coldChainTemplatePricingDetail.freightTemplatePricingDTOList.forEach(item => {
										row.showname = e.showname
										row.areaname = e.areaname
										row.freemoney = e.freemoney
										row.transportMode = 2
										row.pricingType = e.coldChainTemplatePricingDetail.pricingType
										row.detailtype = e.coldChainTemplatePricingDetail.detailtype
										item.freightMoney = this.$fxUtils.toFixedSHW(item.freightMoney, 2)
										item.percentMoney = this.$fxUtils.toFixedSHW(item.freightRatio, 2)
										if (item.pricingType !== 5 && item.pricingType !== 6) {
											item.minValue = this.$fxUtils.toFixedSHW(item.minValue, 2)
											item.maxValue = item.maxValue === null ? '' : this.$fxUtils.toFixedSHW(item.maxValue, 2)
										}
										dto.push(item)
									})
									row.freightTemplatePricingDTOList = dto
									arr.push(row)
								}
								// e.freightTemplatePricingDTOList.forEach(item => {
								// 	item.freightMoney = this.$fxUtils.toFixedSHW(item.freightMoney, 2)
								// 	item.percentMoney = this.$fxUtils.toFixedSHW(item.freightRatio, 2)
								// 	if (item.pricingType !== 5 && item.pricingType !== 6) {
								// 		item.minValue = this.$fxUtils.toFixedSHW(item.minValue, 2)
								// 		item.maxValue = item.maxValue === null ? '' : this.$fxUtils.toFixedSHW(item.maxValue, 2)
								// 	}
								// })
							})
							item.detailList = arr
							this.colspanData(index)
						}
						if (item.type === 1) {
							// let newList = []
							res.data.freightTemplateProductAttrplanDTOList.forEach(item => {
								let nameArr = item.areaname.split(',')
								item.showname = item.areaname
								if (nameArr.length > 20) {
									item.showname = nameArr.slice(0, 21).join(',') + '...'
								}
								item.freeMoney = item.freightTemplatePricingDTOList[0].freeMoney
								item.topOffRadio = item.freeMoney === null ? '1' : '2'
								item.colspan = 1
								item.firstCol = true
								// if (item.freightTemplateProductAttrplanDTOList.length === 1) {
								// 	item.freightTemplatePricingDTOList = [item.freightTemplateProductAttrplanDTOList[0].freightTemplatePricingDTOList[0]]
								// 	item.pricingType = item.freightTemplateProductAttrplanDTOList[0].pricingType
								// 	item.productAttrplanId = item.freightTemplateProductAttrplanDTOList[0].productAttrplanId
								// 	item.productAttrplanName = item.freightTemplateProductAttrplanDTOList[0].productAttrplanName
								// 	item.productId = item.freightTemplateProductAttrplanDTOList[0].productId
								// 	item.productName = item.freightTemplateProductAttrplanDTOList[0].productName
								// 	item.freeMoney = item.freightTemplateProductAttrplanDTOList[0].freightTemplatePricingDTOList[0].freeMoney
								// 	newList.push(item)
								// } else {
								// 	let arr1 = []
								// 	for (let i = 0; i < item.freightTemplateProductAttrplanDTOList.length; i++) {
								// 		let e = item.freightTemplateProductAttrplanDTOList[i]
								// 		let newItem = this.$fxUtils.deepClone(item)
								// 		newItem.freightTemplatePricingDTOList = e.freightTemplatePricingDTOList
								// 		newItem.pricingType = e.pricingType
								// 		newItem.productAttrplanId = e.productAttrplanId
								// 		newItem.productAttrplanName = e.productAttrplanName
								// 		newItem.productId = e.productId
								// 		newItem.productName = e.productName
								// 		newItem.freeMoney = e.freightTemplatePricingDTOList[0].freeMoney
								// 		arr1.push(newItem)
								// 	}
								// 	newList.push(...arr1)
								// }
							})
							item.detailList = res.data.freightTemplateProductAttrplanDTOList
							this.colspanData(index)
						}
						// }
						item.showFlag = !item.showFlag
					}
				})
			}
		},
		colspanData (index) {
			// let copyData = this.$fxUtils.deepClone(this.templateList[index].detailList)
			// copyData[0].colspan = 1
			// copyData[0].firstCol = true
			// let num = 1
			// for (let i = 1; i < copyData.length; i++) {
			// 	let item = copyData[i]
			// 	item.colspan = 1
			// 	item.firstCol = true
			// 	if (item.areaname === copyData[i - 1].areaname) {
			// 		copyData[i - num].colspan = copyData[i - num].colspan + 1
			// 		copyData[i - num].firstCol = false
			// 		item.firstCol = false
			// 		num += 1
			// 	} else {
			// 		num = 1
			// 	}
			// }
			// this.templateList[index].detailList = copyData
			let copyData = this.sortClass(this.templateList[index].detailList)
			copyData.forEach(item => {
				if (item.length === 1) {
					item[0].colspan = 1
					item[0].firstCol = true
				} else {
					let num = 0
					let index = 0
					item.forEach((e, eIndex) => {
						e.colspan = 1
						e.firstCol = false
						// if (e.searchShow) {
						item[index].colspan = item[index].colspan + num
						if (num === 0) {
							if (eIndex === item.length - 1) {
								e.firstCol = true
							} else {
								index = eIndex
								num = 1
							}
						}
						// }
					})
				}
			})
			let finalData = []
			copyData.forEach(item => {
				finalData.push(...item)
			})
			this.templateList[index].detailList = finalData
		},
		sortClass (sortData) {
			const groupBy = (array, f) => {
				let groups = {}
				array.forEach((o) => {
					let group = JSON.stringify(f(o))
					groups[group] = groups[group] || []
					groups[group].push(o)
				})
				return Object.keys(groups).map((group) => {
					return groups[group]
				})
			}
			const sorted = groupBy(sortData, (item) => {
				return item.areaname // 返回需要分组的对象
			})
			return sorted
		},
		objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
			if (column.property === 'freemoney') {
				if (row.firstCol) {
					return {
						rowspan: 1,
						colspan: 1
					}
				} else if (row.colspan && row.colspan !== 1) {
					return {
						rowspan: row.colspan,
						colspan: 1
					}
				} else {
					return {
						rowspan: 0,
						colspan: 0
					}
				}
			}
			if (columnIndex === 0) {
				if (row.firstCol) {
					return {
						rowspan: 1,
						colspan: 1
					}
				} else if (row.colspan && row.colspan !== 1) {
					return {
						rowspan: row.colspan,
						colspan: 1
					}
				} else {
					return {
						rowspan: 0,
						colspan: 0
					}
				}
			}
		},
		setTemplate (row) {
			this.chooseData = row
			this.chooseId = row.uniqueId
			this.normalId = this.chooseData.freightTemplateId || ''
			this.specialId = this.chooseData.productFreightTemplateId || ''
			this.getTemplate()
			this.dialogModel = true
		},
		initIschoose () {
			this.tableSelectUtils.setTableDefaultSelect(this.tableData, this.$refs.table)
		},
		clear () {
			this.tableSelectUtils.clear()
		},
		rowClick (row, column, event) {
			if (this.AuthorityList['11_0001_0001_00'] || this.AuthorityList['11_0001_0002_00']) {
				this.getDetail(row)
			}
		},
		handleSelectionChange (data) {
			this.tableSelectUtils.selectToggle(this.tableData, data)
			let value = this.tableSelectUtils.getSelectRows()
			let ids = value.map(item => {
				return item.uniqueId
			})
			this.$emit('selectIds', ids)
		},
		getDetail (value) {
			window.sessionStorage.setItem('percentageId', value.planid)
			this.$router.push(`/main/percentageDetail`)
		},
		handleSizeChange (value) {
			this.pagination.size = value
			this.$emit('handleSize', value)
		},
		handlePageChange (value) {
			this.pagination.page = value
			this.$emit('handlePage', value)
		}
	}
}
</script>

<style lang="stylus" scoped>
.main-table-freight {
	display flex
	flex: 1
	flex-direction: column
	min-height: 0
	.main-table-box {
		flex: 1
		width: 100%
		// padding-bottom 10px
		box-sizing: border-box;
		overflow: hidden
		overflow-y: auto;
		display flex
		flex-direction: column
	}
	.over-hidden{
		overflow: hidden;
		text-overflow:ellipsis;
		white-space: nowrap;
	}
	.type-box {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-top: 15px;
	}
	.template-list {
		flex: 1;
		margin-top: 15px;
		max-height: 350px;
		color: #333;
		overflow: hidden
		overflow-y: auto
		.template-li {
			border: 1px solid #EDEFFC;
			box-shadow: 0px 1px 4px 1px rgba(199, 199, 199, 0.23);
			border-radius: 2px;
			.template-head {
				display: flex;
				height: 38px;
				padding: 0 10px;
				background-color: #EFEFEF;
				align-items: center;
				cursor: pointer
				i {
					margin-right: 5px
				}
				img {
					margin-right: 5px;
				}
				.head-right {
					margin-left: auto;
					span {
						margin-right: 5px
					}
				}
			}
		}
	}
	.under-line {
		cursor: pointer;
		text-decoration: underline
	}
	.btn-box {
		text-align: right;
		margin-top: 15px;
	}
}
</style>
<style lang="stylus">
.main-table-freight {
	.el-dialog {
		border-radius: 4px
	}
	.el-dialog__title {
		padding-left 10px
		border-left 5px solid var(--fx-primary-color)
	}
	.el-dialog__body {
		padding-top: 10px
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
	// .el-radio-group {
	// 	display flex
	// 	flex-direction: column
	// 	padding: 0 15px 20px
	// 	.el-radio {
	// 		line-height: 30px
	// 	}
	// }
}
</style>
